import { useLang } from "../../i18n/LanguageContext";

export const TrackRecord = () => {
  const { t } = useLang();

  return (
    <section
      id="track-record"
      data-testid="track-record-section"
      className="relative py-16 lg:py-20 border-t border-white/5 bg-[#0A0E17]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 text-[#00E5FF] font-mono text-xs uppercase tracking-[0.24em]">
            <span className="w-6 h-px bg-[#00E5FF]" />
            {t.track.eyebrow}
          </div>
          <h2
            data-testid="track-record-title"
            className="mt-5 font-heading font-bold text-white text-3xl sm:text-4xl lg:text-5xl leading-[1.1] tracking-tight"
          >
            {t.track.title}
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-5">
          {t.track.items.map((item, i) => (
            <article
              key={i}
              data-testid={`track-item-${i}`}
              className="group relative border border-white/10 bg-[#0B0F19] p-6 lg:p-7 rounded-sm hover:border-[#00E5FF]/40 transition-colors duration-300"
            >
              <span className="block font-mono text-[10px] uppercase tracking-widest text-slate-500">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="mt-4 font-heading font-extrabold text-[#00E5FF] text-2xl lg:text-3xl tracking-tight">
                {item.value}
              </div>
              <h3 className="mt-4 font-heading font-bold text-white text-base leading-snug">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-slate-400 leading-relaxed">
                {item.body}
              </p>
              <span
                aria-hidden="true"
                className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-[#00E5FF]/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrackRecord;
